import React, { useContext, useState } from 'react';
import MainStore from '../stores/MainStore';
import { downloadLetterOfAuthority } from '../Utils/UkPrefill';
import UkDocumentUpload, { documentButtonStyle, DOCUMENT_COLORS } from './UkDocumentUpload';

const UkLetterOfAuthority = ({ id, value, onChange }) => {
  const mainStore = useContext(MainStore);
  const contactIndex = Number(/_(\d+)_/.exec(id)?.[1] || 0);
  const [failed, setFailed] = useState(false);

  const download = async () => {
    setFailed(false);
    try {
      await downloadLetterOfAuthority(mainStore, contactIndex);
    } catch (error) {
      setFailed(true);
    }
  };

  return (
    <UkDocumentUpload
      id={id}
      title="Letter of Authority (signed by a director)"
      required
      description="The main contact is not a director/officer - a signed Letter of Authority must evidence their authority to act."
      value={value}
      onChange={onChange}
      hasError={failed}
      errorMessage="The Letter of Authority could not be downloaded. Please try again."
      extraAction={
        <button type="button" style={documentButtonStyle(DOCUMENT_COLORS.orange, DOCUMENT_COLORS.orange)} onClick={download}>
          Download pre-filled PDF
        </button>
      }
    />
  );
};

export default UkLetterOfAuthority;
